import { useState, type ReactNode } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import ActionMenuItem, {
  type ActionMenuItemProps,
} from "@/v2-backoffice-client/components/actionMenu/ActionMenuItem"

export type ActionMenuConfirmItemProps = ActionMenuItemProps & {
  confirmTitle?: ReactNode
  confirmDescription?: ReactNode
  confirmText?: ReactNode
  confirmVariant?: ButtonProps["variant"]
  onConfirm(): void | Promise<void>
}

function ActionMenuConfirmItem(props: ActionMenuConfirmItemProps) {
  const {
    confirmDescription,
    confirmVariant = "destructive",
    onConfirm,
    children,
    ...menuItemProps
  } = props

  const [isPending, setIsPending] = useState(false)

  const pendingVariant =
    confirmVariant === "success"
      ? "success"
      : confirmVariant === "warning"
        ? "warning"
        : "destructive"

  return (
    <ActionMenuItem
      {...menuItemProps}
      iconSrc={isPending ? "check" : menuItemProps.iconSrc}
      variant={isPending ? pendingVariant : menuItemProps.variant}
      className={cn(
        isPending && `action-menu-item-pending-${pendingVariant}`,
        menuItemProps.className,
      )}
      onSelect={(e) => {
        if (isPending) {
          setIsPending(false)
          onConfirm()
        } else {
          e.preventDefault()
          setIsPending(true)
        }
      }}
    >
      <span className="action-menu-confirm-content">
        <span className={cn(isPending && "invisible")}>{children}</span>
        {isPending && (
          <span className="action-menu-confirm-pending">
            <span className="action-menu-confirm-pending-text">
              {confirmDescription ?? "Are you sure?"}
            </span>
            <Button
              className="action-menu-confirm-cancel"
              variant="outline"
              size="tiny"
              onClick={(e) => {
                e.stopPropagation()
                setIsPending(false)
              }}
            >
              Cancel
            </Button>
          </span>
        )}
      </span>
    </ActionMenuItem>
  )
}

export default ActionMenuConfirmItem
